import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Footer from '../Footer/Footer';
import whoban from '../assets/images/who-banner.png';
import brandw from '../assets/images/brandsw.png';
import redoffice from '../assets/images/redoffice.png'
import Getintouch from '../Gettouch/Getintouch';
// import Productslide from '../ProductSection/Productslide';
// for slick-slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import whoslider1 from '../assets/images/whoslider1.png'
// import whoslider2 from '../assets/images/whoslider2.png'
// import whoslider3 from '../assets/images/whoslider3.png'
// import whoslider4 from '../assets/images/whoslider4.png'

import designer from '../assets/images/whoslider1.png';
import dance from '../assets/images/whoslider2.png';
import redteam from '../assets/images/whoslider3.png';
import developer from '../assets/images/whoslider4.png';
import DynamicSlider from '../components/DynamicSlider';

// import Slider from "react-slick";
import TextBanner from './TextBanner';

// var settings = {
//   dots: true,
//   infinite: true,
//   speed: 500,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   margin:10,
//   autoplay: true,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 700,
//       settings: {
//         slidesToShow:1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// };

// for slick-slider end 



const Whoweare = () => {

  const sliderItems = [
    {
      image: designer,
      alt: 'Designer',
      title: 'Designer Team',
      description: 'Designer Team Description for Slider Item'
    },
    {
      image: dance,
      alt: 'Dance',
      title: 'Dance Team',
      description: 'Dance Team Description for Slider Item'
    },
    {
      image: redteam,
      alt: 'redcube',
      title: 'redcube team',
      description: 'Redcube team Description for Slider Item 3'
    },
    {
      image: developer,
      alt: 'developer',
      title: 'developer team',
      description: 'Developer Team Description for Slider Item 3'
    }
  ];
  return (
    <>


  {/* new banner dynamic */}

    <TextBanner
          imageUrl={whoban}
          altname="Who we are"
          title="We listen, we learn, we craft strategies that sing your brand's tune."  
        />
      {/*  new banner dynamic end */}


        {/* top slider  */}

        <DynamicSlider sliderItems={sliderItems} />

        {/* top slider  */}

      {/* <section className='whoslider pt-0'>
        <Container>
          <Row>
            <Col lg={12}>
              <Slider {...settings}>
                <div>
                <img src={whoslider1} alt="Slide1" />
                </div>
                <div>
                <img src={whoslider2} alt="Slide1" />
                </div>
                <div>
                <img src={whoslider4} alt="Slide1" />
                </div>
                <div>
                <img src={whoslider3} alt="Slide1" />
                </div>
               
              </Slider>
            </Col>
          </Row>
        </Container>
      </section> */}




      {/* our mision  and vision section */}
      <section className='ourmissionv'>
        <Container>
          <Row>
            <Col lg={6}>
              <h2>Vision</h2>
              <p>To become growth driven topmost provider of 360 degree digital marketing services every day of the year. </p>
            </Col>
            <Col lg={6}>
              <h2>Mission</h2>
              <p>To continue providing value for money to all our clients and keep delighting them in the digital space. </p>
            </Col>
          </Row>
        </Container>
      </section>
      {/* our great brands */}

      <section className='greatbrand'>
        <Container>
          <Row>
            <Col lg={6}>
              <p>The journey of making great BRANDS begins with great work well-defined by the faith advertised among customers! We believe that the success of any brand lies not only in results but also in efforts made and we make our earnest efforts to make your company- a BRAND name by doing the best. </p>
            </Col>
            <Col lg={6}>
              <img src={brandw} alt="brands" />
            </Col>
          </Row>
        </Container>
      </section>

      <section className='textpara'>
        <Container>
          <Row>
            <Col lg={12}>
              <p>Started in 2010, Red Cube Digital Media began with the thought of doing something extraordinary for each of our clients that makes them stand out in their own respective field. Today, our innovative, interactive, award winning and remarkably result driven projects have made Red cube Digital as one of the leading digital marketing companies in India. We are a digital agency with holistic digital marketing solutions, known for our strategic brand results and outstanding innovations.  </p>
            </Col>
            <Col lg={12} className='text-center p-lg-5 p-3' >
              <img src={redoffice} alt="Redcube Digital" />
            </Col>
            <Col lg={12}>
              <p>We are chosen as a Digital Marketing Agency by startups as well as corporate giants because of our ability to assess, scrutinize and responding to the environment instantly with the aim of providing the best outcome desired. Our brand value is based on impeccable results, well-grounded ROI, efficient method of solving problems and customized solutions based on the needs and requirements of our clients. </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* get in touch */}
      <section className='p-0'>
        <Getintouch />
      </section>


      {/* Footer  */}
      <section className='p-0' >
        <Footer />
      </section>
    </>
  );
};

export default Whoweare;